const monthDayYear = (date, locale = 'en-US', longMonth = true) => {
  return new Date(date).toLocaleDateString(locale, {
    month: longMonth ? 'long' : 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

const formattedDate = (date, timezoneId, languageRegionCode = 'en-US') => {
  if (timezoneId) {
    return date.toLocaleDateString(languageRegionCode, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: timezoneId,
      timeZoneName: 'short'
    });
  }
  return date.toLocaleDateString(languageRegionCode, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};

const dateString = (date = new Date(), timezone = null, languageRegionCode = 'en-US') => {
  return timezone
    ? new Date(date).toLocaleDateString(languageRegionCode, {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZone: timezone,
        timeZoneName: 'short'
      })
    : new Date(date).toLocaleDateString(languageRegionCode, {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });
};

const daysAgoInSeconds = days => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d / 1000; // ms -> s
};

const localizedFormat = (abbreviate = false, locale = 'en-US') => {
  switch (locale) {
    case 'en-US':
      return abbreviate ? 'MMM. dd, yyyy' : 'MMMM dd, yyyy';
    case 'de-DE':
      return abbreviate ? 'dd. MMM. yyyy' : 'dd. MMMM yyyy';
    case 'fr-FR':
      return abbreviate ? 'dd MMM yyyy' : 'dd MMMM yyyy';
    case 'es-ES':
      return abbreviate ? "dd 'de' MMM. 'de' yyyy" : "dd 'de' MMMM 'de' yyyy";
    default:
      return abbreviate ? 'MMM dd, yyyy' : 'MMMM dd, yyyy';
  }
};

const isToday = potentialDate => {
  const date = new Date(potentialDate);
  const today = new Date();

  return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() && today.getFullYear();
};

export { formattedDate, monthDayYear, daysAgoInSeconds, dateString, localizedFormat, isToday };
